class SuccessStoriesListItem implements ng.IComponentController {
    backgroundImage: string;
    logo: string;
    description: string;
}

angular.module('animatronApp.successStoriesListItem', []).component('successStoriesListItem', {
    bindings: {
        logo: '<?',
        description: '<?',
        backgroundImage: '<',
    },
    controller: SuccessStoriesListItem,
    templateUrl: require('landing-template/components/success-stories-list-item.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/SuccessStoriesListItem.ts